export default class Audit {
    audit_id: string;
    field_name: string;
    old_field_value: string;
    new_field_value: string;
    created_date: string;
    created_by: string;

    constructor(
        audit_id: string,
        field_name: string,
        old_field_value: string,
        new_field_value: string,
        created_date: string,
        created_by: string,
    ) {
        this.audit_id = audit_id;
        this.field_name = field_name;
        this.old_field_value = old_field_value;
        this.new_field_value = new_field_value;
        this.created_date = created_date;
        this.created_by = created_by;
    }

    public static initialiseAudit(responses: any): Audit[] {
        let records: Audit[] = [];
        for(const record of responses) {
            const auditRecord = new Audit(
                record.audit.audit_id,
                record.field.field_name,
                record.audit.old_field_value,
                record.audit.new_field_value,
                record.audit.created_date,
                record.audit.created_by,
            );
            records.push(auditRecord);
        }
        return records;
    }
}